// extracted by mini-css-extract-plugin
module.exports = {"root":"_c9e08e24","filters":"_1e6f6e99","hasTopMargin":"_c6cf600a"};